import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.azure';

/*import { environment } from '../../../environments/environment.development';*/


@Injectable({
  providedIn: 'root'
})
export class ApiUrlService {


  private urlApiEndV3: string = environment.urlApiEndPointV3;


  //LOGIN//
  private readonly LOGIN_USER_API_END: string = '/users/user-info-recover';

  get loginUserApiEnd(): string {
    return `${this.urlApiEndV3}${this.LOGIN_USER_API_END}`;
  }

  private readonly TOKEN_USER_API_END: string = '/token';

  get tokenUserApiEnd(): string {
    return `${this.urlApiEndV3}${this.TOKEN_USER_API_END}`;
  }

  private readonly STATUS_USER_API_END: string = '/status';

  get statusUserApiEnd(): string {
    return `${this.urlApiEndV3}${this.STATUS_USER_API_END}`;
  }



  private readonly OBTENER_LISTADO_SOLICITUDES_API_END: string = '/requests/get-requests'
  private readonly OBTENER_DETALLE_SOLICITUD_API_END: string = '/requests/get-request-details'
  private readonly CREAR_SOLICITUD_API_END: string = '/requests/create-request'
  private readonly ACTUALIZAR_SOLICITUD_API_END: string = '/requests/update-request-details'
  private readonly OBTENER_IMAGEN_DETALLE: string = '/requests/get-request-image'
  private readonly UPLOAD_IMAGEN_SOLICITUD: string = '/requests/upload-request-image'
  private readonly OBTENER_HISTORIAL_SOLICITUD_API_END: string = '/requests/get-solicitud-historial'
  private readonly LISTADO_USUARIOS_API_END: string = '/users/get-users-list'
  private readonly LISTADO_USUARIOS_DETAILS_API_END: string = '/users/get-users-details'
  private readonly NUEVO_USUARIO_API_END: string = '/users/create-user'
  private readonly ACTUALIZAR_USUARIO_API_END: string = '/users/update-user'
  private readonly ELIMINAR_USUARIO_API_END: string = '/users/delete-user'
  private readonly ACTUALIZAR_SOLICITUD_ESTADO: string = '/requests/update-request-status'



  get listadoSolicitudes(): string {
    return `${this.urlApiEndV3}${this.OBTENER_LISTADO_SOLICITUDES_API_END}`;
  }

  get detalleSolicitud(): string {
    return `${this.urlApiEndV3}${this.OBTENER_DETALLE_SOLICITUD_API_END}`;
  }

  get crearSolicitud(): string {
    return `${this.urlApiEndV3}${this.CREAR_SOLICITUD_API_END}`;
  }

  get listadoUsuariosSimple(): string {
    return `${this.urlApiEndV3}${this.LISTADO_USUARIOS_API_END}`;
  }

  get listadoUsuarios(): string {
    return `${this.urlApiEndV3}${this.LISTADO_USUARIOS_DETAILS_API_END}`;
  }

  get actualizarSolicitud(): string {
    return `${this.urlApiEndV3}${this.ACTUALIZAR_SOLICITUD_API_END}`;
  }

  get nuevoUsuario(): string {
    return `${this.urlApiEndV3}${this.NUEVO_USUARIO_API_END}`;
  }

  get actualizarUsuario(): string {
    return `${this.urlApiEndV3}${this.ACTUALIZAR_USUARIO_API_END}`;
  }

  get eliminarUsuario(): string {
    return `${this.urlApiEndV3}${this.ELIMINAR_USUARIO_API_END}`;
  }

  get solicitudImage(): string {
    return `${this.urlApiEndV3}${this.OBTENER_IMAGEN_DETALLE}`;
  }

  get uploadImagenSolicitud(): string {
    return `${this.urlApiEndV3}${this.UPLOAD_IMAGEN_SOLICITUD}`;
  }

  get actualizarSolicitudEstado(): string {
    return `${this.urlApiEndV3}${this.ACTUALIZAR_SOLICITUD_ESTADO}`;
  }

  get obtenerHistorialSolicitud(): string {
    return `${this.urlApiEndV3}${this.OBTENER_HISTORIAL_SOLICITUD_API_END}`;
  }
}
